import { IAttrValue } from "@multiweb/types/contracts";
import { DataConverter } from "Global/Base/Converters/DataConverter";
import { NumberUtils } from "../../../../Global/Base/Utils/NumberUtils";
import { CultureInfo } from "../../../../Global/Dom/CultureInfo";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DefaultEditTemplate } from "../Templates/DataTypeEditTemplates/DefaultEditTemplate";
import { NumItemTemplate } from "../Templates/NumItemTemplate";
import { Column } from "./Column";

export class NumberColumn extends Column {
    //#region Fields
    private static _formatOpts: Map<string, Intl.NumberFormatOptions> = new Map<string, Intl.NumberFormatOptions>();
    private _minValue: number;
    private _maxValue: number;
    //#endregion

    protected static override get observedAttributes(): string[] {
        return ["data-minvalue", "data-maxvalue"].concat(Column.observedAttributes);
    }

    public get minValue(): number {
        return this._minValue;
    }

    public set minValue(value: number) {
        this._minValue = value;
    }

    public get maxValue(): number {
        return this._maxValue;
    }

    public set maxValue(value: number) {
        this._maxValue = value;
    }

    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array)
            return "";

        const val = AttrValueReader.read(data);
        if (val == null || val.toString() === "")
            return "";

        if (!NumberColumn._formatOpts.has(this.displayFormat)) {
            NumberColumn._formatOpts.set(this.displayFormat, NumberUtils.getStandardNumberFormatOptions(this.displayFormat, undefined, this.dataType));
        }

        const opts = NumberColumn._formatOpts.get(this.displayFormat);

        return val.toLocaleString(CultureInfo.getCultureInfo().name, opts);
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new NumItemTemplate();
        this.editItemTemplate = new DefaultEditTemplate();
    }
    //#endregion HTMLElement

    /**
     * Reakce na změny attributu
     * @param attrName - název změněného atributu
     * @param oldVal - původní hodnota
     * @param newVal - nová hodnota
     */
    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        switch (attrName) {
            case "data-minvalue":
                this.minValue = DataConverter.toNumberOrUndefined(newVal);
                break;
            case "data-maxvalue":
                this.maxValue = DataConverter.toNumberOrUndefined(newVal);
                break;
        }
    }

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-numbercolumn", NumberColumn);
